exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#styleguide .search-bar-container{width:30rem}", ""]);

// exports
